import { createStore } from 'vuex'
import { adminPage } from './adminPage.js'
import Login from '../admin/login.vue'
// 创建一个新的 store 实例
export default createStore({
  state () {
    return {
      adminPage: adminPage,
      Login: false

    }
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
})

